import React, { SVGProps } from "react";
export default function SupUserAnon016(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18 5.38245L10 0.764892L2 5.38245M18 5.38245V14.6176L10 19.2351M18 5.38245L10 9.86113M10 19.2351L2 14.6176V5.38245M10 19.2351V9.86113M2 5.38245L10 9.86113M3.74897 13.6454V8.53002L5.13809 9.34903M3.74897 13.6454L8.36778 16.4924V14.6176M3.74897 13.6454L5.13809 12.8816M16.5983 13.6454V8.33352L14.7924 9.34903M16.5983 13.6454L11.5975 16.4924V14.53M16.5983 13.6454L14.7924 12.8816M14.7924 9.34903L11.5975 11.1457V14.53M14.7924 9.34903V12.8816M14.7924 12.8816L11.5975 14.53M5.13809 12.8816V9.34903M5.13809 12.8816L8.36778 14.6176M5.13809 9.34903L8.36778 11.1457V14.6176M10 2.57025L5.13809 5.45188L6.83975 6.41185M10 2.57025L14.7924 5.45188L13.1151 6.41185M10 2.57025V4.49802M10 4.49802L6.83975 6.41185M10 4.49802L13.1151 6.41185M6.83975 6.41185L10 8.19464L13.1151 6.41185"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
